"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _theme = _interopRequireDefault(require("../../Theme/lib/AirasiaClassic/theme"));
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize"];
var FlatbedUnavailable = function FlatbedUnavailable(props) {
  var fontsize = props.fontsize,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize
    }, theme),
    height = _parseStyles.sizeStyles.height;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    height: height,
    viewBox: "0 0 39 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M0.5 30H2.5C3.60457 30 4.5 30.8954 4.5 32V54L34.5 54V32C34.5 30.8954 35.3954 30 36.5 30C37.6046 30 38.5 30.8954 38.5 32V54V56C38.5 57.1046 37.6046 58 36.5 58L0.5 58V56V54V30Z",
    fill: _theme.default.colors.greyLight
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M0 32C0 30.8954 0.895431 30 2 30C3.10457 30 4 30.8954 4 32V54L34 54V32C34 30.8954 34.8954 30 36 30H38V54V56V58L2 58C0.89543 58 0 57.1046 0 56V54V32Z",
    fill: _theme.default.colors.greyLight
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd"
    // eslint-disable-next-line max-len
    ,
    d: "M6 2V8V9V38V39V48C6 50.2091 7.79086 52 10 52H28C30.2091 52 32 50.2091 32 48V39V38V9V8V2C32 0.89543 31.1046 0 30 0H8C6.89543 0 6 0.895432 6 2Z",
    fill: _theme.default.colors.greyLight
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9989 39.3762L5.23056 12.6078L5.99658 11.8418L32.7649 38.6101L31.9989 39.3762Z",
    fill: _theme.default.colors.greyLighter
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7961 12.9723L6.00675 39.7616L5.24072 38.9956L32.03 12.2063L32.7961 12.9723Z",
    fill: _theme.default.colors.greyLighter
  })));
};
FlatbedUnavailable.propTypes = _inline_svg2.default.propTypes;
FlatbedUnavailable.defaultProps = _inline_svg2.default.defaultProps;
var _default = FlatbedUnavailable;
exports.default = _default;